<mat-sidenav-container [class.kiosk-mode]="isKioskMode">
    <div id="cards" class="page-layout emma simple fullwidth" [class.kiosk-mode]="isKioskMode">
        <!-- Header -->
        <div class="header accent" fxLayout="row wrap" fxLayoutAlign="space-between" fxFlex="1 0 auto">
            <!-- Title -->
            <div class="title-container">
                <h1>{{ "DASHBOARD.Title" | translate }}</h1>
                <h1 class="view-title">{{ viewTitle }}</h1>
            </div>

            <!-- Toolbar -->
            <div class="toolbar" fxLayout="row" fxLayoutAlign="space-between center" fxFlexOrder="3">
                @if (!editing) {
                    <div>
                        @if (isKioskMode) {
                            <button mat-button class="refresh-toggle" (click)="reloadPage()">
                                <mat-icon class="refresh-toggle__icon">refresh </mat-icon>
                            </button>
                        }
                        <button mat-button class="fullscreen-toggle" (click)="changeKioskMode()">
                            <mat-icon class="fullscreen-toggle__icon">present_to_all </mat-icon>
                        </button>
                        @if (currentView && !isKioskMode) {
                            <button mat-button (click)="edit()">
                                <mat-icon>edit </mat-icon>
                            </button>
                        }
                        <!-- Dashboard View Buttons -->
                        <button mat-raised-button class="navbar-button" (click)="dashboardSidenav.toggle()">
                            <mat-icon>view_compact </mat-icon>
                            {{ "DASHBOARD.SwitchViews" | translate }}
                        </button>
                    </div>
                }
                @if (editing) {
                    <div class="editing-controls">
                        <mat-slide-toggle [(ngModel)]="showConnected" (ngModelChange)="onShowConnected()"
                            ><span class="editing-controls__label">{{ "DEVICES.ConnectedDevices" | translate }}</span></mat-slide-toggle
                        >
                        <mat-slide-toggle [(ngModel)]="showEventStream" (ngModelChange)="onShowEventStream()"
                            ><span class="editing-controls__label">{{ "DASHBOARD.EventStream" | translate }}</span></mat-slide-toggle
                        >
                        <button mat-raised-button class="navbar-button" color="warn" (click)="edit()">
                            <mat-icon>check </mat-icon>
                            {{ "DASHBOARD.Done" | translate }}
                        </button>
                    </div>
                }

                <!--button mat-icon-button aria-label="Settings" matTooltip="Settings">

      </button-->
                <!-- / Dashboard View Buttons -->
            </div>
            <!-- / Toolbar -->
        </div>
        <!-- / Header -->

        <div class="content">
            <gridster [options]="options">
                @for (graph of graphs; track graph) {
                    <gridster-item [item]="graph">
                        @if (graph.customWidget) {
                            <app-custom-widget-card
                                class="emma-card auto-width"
                                [widget]="graph.customWidget"
                                [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                            ></app-custom-widget-card>
                        } @else {
                            @switch (graph.dataType) {
                                @case (DataTypeModelKey.onlineDevices) {
                                    <app-connected-devices
                                        class="emma-card auto-width"
                                        [devices]="devices"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </app-connected-devices>
                                }
                                @case (DataTypeModelKey.soundPressureLevel) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.soundPressureLevelC) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.soundPressureLevelC"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.soundPressureLevelCMinusA) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.soundPressureLevelCMinusA"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.rolling5) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.rolling5"
                                        [showAvg5]="false"
                                        [showAvg30]="false"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.rolling5C) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.rolling5C"
                                        [showAvg5]="false"
                                        [showAvg30]="false"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.rolling5s) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.rolling5s"
                                        [showAvg5]="false"
                                        [showAvg30]="false"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.rolling5sC) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.rolling5sC"
                                        [showAvg5]="false"
                                        [showAvg30]="false"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.rolling30) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.rolling30"
                                        [showAvg5]="false"
                                        [showAvg30]="false"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.rolling30C) {
                                    <device-card-soundpressure
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.rolling30C"
                                        [showAvg5]="false"
                                        [showAvg30]="false"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-soundpressure>
                                }
                                @case (DataTypeModelKey.spectrum13Octave) {
                                    <device-band-spectra
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.spectrum13Octave"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-band-spectra>
                                }
                                @case (DataTypeModelKey.spectrum13Octave1Minute) {
                                    <device-band-spectra
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [dataType]="DataTypeModelKey.spectrum13Octave1Minute"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-band-spectra>
                                }
                                @case (DataTypeModelKey.battery) {
                                    <device-card-battery
                                        class="emma-card auto-width"
                                        [device]="graph.device"
                                        [showDeviceLink]="!isKioskMode"
                                        [ngClass]="{ 'emma-card-kiosk': isKioskMode }"
                                    >
                                    </device-card-battery>
                                }
                                @case (DataTypeModelKey.eventStream) {
                                    <div class="emma-card auto-width">
                                        <div class="emma-card__header">Events Stream</div>
                                        <event-stream></event-stream>
                                    </div>
                                }
                            }
                        }
                    </gridster-item>
                }
            </gridster>
        </div>
    </div>

    <!-- Side nav -->
    <mat-sidenav #dashboardSidenav position="end">
        <app-dashboard-sidebar></app-dashboard-sidebar>
    </mat-sidenav>
</mat-sidenav-container>
